class ViewInRoom extends HTMLElement {
  static observedAttributes = ["current-variant"];

  constructor() {
    super();

    this.addEventListener("variant:changed", (e) =>
      this.setAttribute("current-variant", e.detail?.variant?.id),
    );

    this.querySelector("[data-change-background]")?.addEventListener(
      "click",
      () => this.changeBackground(),
    );

    this.backgroundIndex = 0;
  }

  connectedCallback() {}

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {
    this.querySelectorAll(`[data-variant-id]`).forEach((el) => {
      el.style.display = "none";
    });
    this.querySelectorAll(`[data-variant-id="${newValue}"]`).forEach((el) => {
      el.style.display = null;
    });
  }

  changeBackground() {
    const backgrounds = this.querySelectorAll("view-in-room-preview");
    const newIndex =
      this.backgroundIndex >= backgrounds.length - 1
        ? 0
        : this.backgroundIndex + 1;
    this.backgroundIndex = newIndex;

    backgrounds.forEach((background, i) => {
      background.style.display = i === newIndex ? null : "none";
    });
  }
}

if (!customElements.get("view-in-room")) {
  customElements.define("view-in-room", ViewInRoom);
}
